import { connect } from 'react-redux'
import Gate from './../'
import login from './../../../actions/login'

const mapStateToProps = (state) => {
  return {
    open: !!state.auth.authed,
    initialized: state.auth.init,
    loading: !state.auth.init
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onInit: () => dispatch(login.refreshAuth())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Gate)
